import { render, staticRenderFns } from "./changBaseStationDialog.vue?vue&type=template&id=678d744f&scoped=true"
import script from "./changBaseStationDialog.vue?vue&type=script&lang=js"
export * from "./changBaseStationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d744f",
  null
  
)

export default component.exports